/**
 * Color Tokens - Base values from export.json
 */

export const colors = {
  // chakra defaults needed until we have added more recipes
  // Separator
  border: {
    DEFAULT: { value: '#e5e5e5' },
  },

  grey: {
    50: { value: '#fafafa' },
    100: { value: '#f9f9f9' },
    200: { value: '#e5e5e5' },
    300: { value: '#cccccc' },
    400: { value: '#b3b3b3' },
    500: { value: '#999999' },
    600: { value: '#808080' },
    700: { value: '#666666' },
    800: { value: '#4c4c4c' },
    900: { value: '#333333' },
    950: { value: '#0f1313' },
    white: { value: '#ffffff' },
    muted: { value: '#999999cc' },
  },
  green: {
    100: { value: '#f5faf9' },
    200: { value: '#ecf7f3' },
    300: { value: '#d4f2e7' },
    400: { value: '#53c098' },
    500: { value: '#3ba07b' },
    600: { value: '#387d64' },
    700: { value: '#266a52' },
    transparent: { value: 'rgba(59, 160, 123, 0.6)' },
  },
  blue: {
    100: { value: '#fbfcff' },
    200: { value: '#f6faff' },
    300: { value: '#e4f1ff' },
    400: { value: '#71a1ee' },
    500: { value: '#356ec8' },
    600: { value: '#2357a8' },
    700: { value: '#2d4b7a' },
    transparent: { value: 'rgba(53, 110, 200, 0.6)' },
  },
  red: {
    100: { value: '#fffbfb' },
    200: { value: '#fff3f3' },
    300: { value: '#ffdddd' },
    400: { value: '#f39897' },
    500: { value: '#d66462' },
    600: { value: '#cb4a4a' },
    700: { value: '#af2c2a' },
    transparent: { value: 'rgba(214, 100, 98, 0.6)' },
  },
  yellow: {
    100: { value: '#fefcf6' },
    200: { value: '#FFF7DC' },
    300: { value: '#ffedb2' },
    400: { value: '#f7ce66' },
    500: { value: '#f5b30c' },
    600: { value: '#b97f00' },
    700: { value: '#7a5200' },
  },
  purple: {
    100: { value: '#fdfcfe' },
    200: { value: '#f0edfe' },
    300: { value: '#e1dbff' },
    400: { value: '#6e5cbf' },
    500: { value: '#4d3c9e' },
    600: { value: '#372c7a' },
    700: { value: '#231b53' },
  },
  skyBlue: {
    100: { value: '#f9fdff' },
    200: { value: '#ebf1f3' },
    300: { value: '#d8e9f0' },
    400: { value: '#5bb1d4' },
    500: { value: '#1092c8' },
    600: { value: '#0f5f86' },
    700: { value: '#20333b' },
  },
  blackAlpha: {
    500: { value: 'rgba(0, 0, 0, 0.5)' },
  },
};
